var BASEURL = "https://youthful-chaum.180-179-213-167.plesk.page";

//'http://localhost:3001';

export const EndPoint = {
    BASEURL: BASEURL,
    LOGIN: `${BASEURL}/users/login`,
    USERS: `${BASEURL}/users`,
    STATES: `${BASEURL}/states`,
    COUNTRY: `${BASEURL}/country`,
    USERROLE: `${BASEURL}/roles`,
    LEADSOURCES: `${BASEURL}/leadsources`,
    ITEMS: `${BASEURL}/items`,
    CATEGORY: `${BASEURL}/category`,
    COMPANY: `${BASEURL}/company`,
    MODULES: `${BASEURL}/modules`,
    STATUSES: `${BASEURL}/statuses`,
    PRIORITIES: `${BASEURL}/priorities`,
    PROBABILITY: `${BASEURL}/probability`,
    TAXGROUPS: `${BASEURL}/taxgroups`,
    TENDERS: `${BASEURL}/tenders`,
    LEADS: `${BASEURL}/leads`,
    CUSTOMERS: `${BASEURL}/customers`,
    ACTIVITY: `${BASEURL}/activity`,
    INVOICES: `${BASEURL}/invoices`,
    SERVICE: `${BASEURL}/service`,
    QUOTES: `${BASEURL}/quotes`,
    LOCALE:`${BASEURL}/locale`,
}